export function ajax({
    method = 'GET',
    url = '',
    async = false,
    body = null,
    headers = {},
    withCredentials = false,
    success = () => {},
    error = () => {}
}) {
    // 1. 创建http对象
    const http = new XMLHttpRequest();

    // 2. 建立连接
    http.open(method, url, async);

    // 3. 设置请求头信息
    for (const key in headers) {
        if (Object.hasOwnProperty.call(headers, key)) {
            http.setRequestHeader(key, headers[key]);
        }
    }

    http.withCredentials = withCredentials;

    // 4. 发送请求
    http.send(body);

    // 5. 监听请求状态
    http.onreadystatechange = () => {
        if (http.readyState === 4) {
            if (http.status === 200) {
                success(http.responseText);
            } else {
                error(http.responseText);
            }
        }
    };
}
